// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"1078":"25377e70e7990fe8b78a","4813":"7fe881debc049921bf8e","5157":"e55ff106b5d92a608043"}[chunkId] + ".js";
};